import BaseApi from './baseApi';
import ICompanyContacts from '../models/ICompanyContacts';
import IAuthentication from '../models/IAuthentication';
export default class CompanyContactsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Companies");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompanyContacts(companyId: string) : Promise<ICompanyContacts[]> {
        const json = this.getJsonRead(companyId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var companyContacts: ICompanyContacts[] = [];
            companyContacts = response.data as ICompanyContacts[];
            return companyContacts;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompanyContact(companyContact: ICompanyContacts) : Promise<string> {
        const json = this.getJsonSave(companyContact);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompanyContact(companyContact: ICompanyContacts) : Promise<boolean> {
        const json = this.getJsonUpdate(companyContact);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompanyContact(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesContacts",
            "conditions": [{
                "Item1": "CompaniesContacts",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(companyContact: ICompanyContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": companyContact.name
            }, {
                "Item1": "Email",
                "Item2": companyContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": companyContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": companyContact.phoneNumber
            }, {
                "Item1": "IdCompany",
                "Item2": companyContact.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesContacts"
        };
        return json;
    }

    private getJsonUpdate(companyContact: ICompanyContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": companyContact.name
            }, {
                "Item1": "Email",
                "Item2": companyContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": companyContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": companyContact.phoneNumber
            }, {
                "Item1": "IdCompany",
                "Item2": companyContact.idCompany
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesContacts",
            "keyvalue": companyContact.id
        };
        return json;
    }

    private getJsonRead(companyId: string) : any {
        const json = {
            "fields": [{
                "Item1": "CompaniesContacts",
                "Item2": "id"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "name"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "email"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "phoneNumber"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "CompaniesContacts"
            }, {
                "Item1": "ListPhonePrefixes"
            }],
            "joins": [{
                "Item1": "CompaniesContacts",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "CompaniesContacts",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CompaniesContacts",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": companyId
            }]
        };
        return json;
    }
}
